import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defer, map, Observable } from 'rxjs';
import { ClientService } from 'src/app/services/client.service';
import { TenantService } from 'src/app/services/tenant.service';

@Pipe({
  name: 'serviceText',
  standalone: true,
})
export class ServiceTextPipe implements PipeTransform {
  constructor(private readonly tenantService: TenantService, private translate: TranslateService, private clientService: ClientService) { }

  

  transform(serviceCode: string | null | undefined): Observable<string> {
    return defer(() => {
      if (!serviceCode) {
        return [''];
      }

      if (serviceCode === 'T30') {
        return [this.translate.instant(serviceCode)];
      }

      const lowerCode = serviceCode.toLowerCase();

      return this.tenantService.services$.pipe(
        map((tenantServices) => {          
          // tenantService.guid match => clientService.guid match 'this allways returns something'
          let foundMatch = tenantServices.find(s => s.id?.toLowerCase() === lowerCode);
          if (foundMatch != undefined)
            return foundMatch.name;
          foundMatch = tenantServices.find(s => s.code?.toLowerCase() === lowerCode);
          if (foundMatch != undefined)
            return foundMatch.name;
          foundMatch = this.clientService.clientServices.find(s => s.id?.toLowerCase() === lowerCode);
          if (foundMatch?.name)
            return foundMatch.name;
          foundMatch = this.clientService.clientServices.find(s => s.code?.toLowerCase() === lowerCode);
          if (foundMatch?.name)
            return foundMatch.name;

          return serviceCode;
        })
      );
    });
  }
}
